const domain = 'lifekh.com';
const domainPrefix = 'boss';
export const md5Key = 'J58l2qudG8uCeae4JcWBl2en9zv7xvFa';
//  当前环境
window.deployEnv = 'local';
if (window.location.origin.indexOf('lifekh.com') !== -1) {
  if (window.location.host.indexOf('boss-merchant-') !== -1) {
    deployEnv = window.location.host.replace(/boss-merchant\-|\.lifekh.com/g, '');
  } else {
    //  生产环境
    deployEnv = '';
  }
}

Vue.prototype = Vue && Vue.prototype || {};
if (!Vue.prototype.ssr) {
  //  处理 ssr 数据
  try {
    Vue.prototype.ssr = window.ssrConfig && JSON.parse(decodeURIComponent(window.ssrConfig)) || ''
  } catch (err) {
    Vue.prototype.ssr = {
      env: 'sit',
      hosts: [
        'boss-merchant-sit.lifekh.com'
      ],
      preFix: 'boss'
    };
  }
  Vue.prototype.ssr && console.log('【Vue.prototype.ssr】', Vue.prototype.ssr);
}
const apolloHost = ((Vue.prototype.ssr || {}).hosts || []).find(e => e === window.location.host) || '';
const urlStr = apolloHost && apolloHost.indexOf(deployEnv) !== -1 && `${window.location.protocol}//${apolloHost}/` || deployEnv === 'local' && `https://boss-merchant-sit.lifekh.com/` || '/';
export const baseURL = urlStr;
export const env = window.location.host.indexOf(domain) !== -1 && (window.location.host.replace(eval(`/${domainPrefix}|-|\.${domain}/g`), '') || 'sit') || '';
export const host = window.location.host.indexOf(domain) !== -1 && window.location.host || `https://${domainPrefix}${env && `-${env}` || ''}.${domain}`;
export const fileUrl = deployEnv && `https://h5-${deployEnv === 'local' && 'sit' || deployEnv}.lifekh.com/` || `https://h5.lifekh.com/`;
export const fileDisplayUrl = `${fileUrl}/files`
//  映射后端模块名
export const moduleNameMap = {
  FILEDISPLAYURL: '',
  USER_CENTER: 'usercenter',
  BOSS_WEB: 'boss_web',
  TW_MERCHANT_BOSS: 'tw-merchant-boss',
  PRODUCT_BOSS: 'takeaway-product',
  TW_MERCHANT_GATEWAY: 'merchantgateway_web',
  TW_COUPON: 'coupon',
  MARKETZONE_BOSS: 'marketzone-boss',
  FILE_WEB: 'file_web',
  DISCOVERY_BOSS: 'discovery'
};
